// @ts-check
import "@fortawesome/fontawesome-pro/js/fontawesome";
import "@fortawesome/fontawesome-pro/js/regular";
import "@fortawesome/fontawesome-pro/js/solid";
import "@fortawesome/fontawesome-pro/js/duotone";
import "@fortawesome/fontawesome-pro/js/brands";

FontAwesome.config.mutateApproach = "sync";
